import script from "./TheAdminCoredataEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAdminCoredataEdit.vue?vue&type=script&setup=true&lang=js"

import "./TheAdminCoredataEdit.vue?vue&type=style&index=0&id=c4862a5c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4862a5c"]])

export default __exports__